export const LOGO_MAX_WIDTH = 260
